import { parseInt } from 'lodash-es';
import { assertMonth } from '../shared/date-types';
import { displayMonth } from '../shared/display';
/**
 * converts date to {year}/{month} format
 * @param year year e.g. 1984
 * @param month month indexed, Jan -> 1, Feb -> 2, ...
 */
export function monthDateToKey(year, month) {
    return `${year}/${month}`;
}
/**
 * inverse of monthDateToKey
 * @param key should be in {year}/{month} format
 */
export function monthKeyToDate(key) {
    const [year, month] = key.split('/');
    const yearParsed = parseInt(year);
    const monthParsed = assertMonth(parseInt(month));
    return [yearParsed, monthParsed];
}
export function displayMonthDate(date, locale = 'en') {
    const [year, month] = date;
    return displayMonth(month, locale) + ' ' + year.toString();
}
